import { SymbolPrice } from "@/components/scanners-page/layout/PageContent";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { UniverseOption } from "@/contexts/PatternUniverse";
import { toNumberAndSign } from "@/helpers/helperFunctions";
import React from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa6";

interface SymbolPriceTableProps {
  selectedUniverse: UniverseOption | undefined;
  symbolPrices: Record<string, SymbolPrice>;
}

export const SymbolPriceTable: React.FC<SymbolPriceTableProps> = ({
  selectedUniverse,
  symbolPrices,
}) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead colSpan={3} className="text-center text-foreground">
            {selectedUniverse?.label ?? "Select universe from above"}
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody className="text-muted-foreground">
        {selectedUniverse?.uList?.map((universe) => {
          let change = symbolPrices[universe]?.change;
          let { isNegative, value } = toNumberAndSign(change ?? 0);
          return (
            <TableRow>
              <TableCell className="text-white">{universe}</TableCell>
              <TableCell>{symbolPrices?.[universe as string]?.price}</TableCell>
              {!(value == 0 || value == Infinity) && (
                <TableCell
                  className={
                    value == 0 || null
                      ? ""
                      : isNegative
                      ? "text-red-foreground"
                      : "text-green-foreground"
                  }
                >
                  <div className="flex flex-row items-center justify-center">
                    {change === null ? (
                      "--"
                    ) : isNegative ? (
                      <>
                        <FaCaretDown className="text-red-foreground" />
                        {value}%
                      </>
                    ) : (
                      <>
                        <FaCaretUp className="text-green-foreground" />
                        {value}%
                      </>
                    )}
                  </div>
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
